import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Principal:',
    desc: 'El manual completo "Metabolismo en Punto de Equilibrio (40+)".'
  }, {
    title: 'El Protocolo 5-5-5:',
    desc: 'La rutina exacta de 15 minutos para encender tus células cada mañana.'
  }, {
    title: 'Mapa de Alimentación de Sostenimiento:',
    desc: 'El orden crítico de los alimentos para eliminar el coma alimenticio.'
  }, {
    title: 'Hojas de Trabajo de Auditoría:',
    desc: 'Para identificar exactamente dónde estás perdiendo energía durante el día.'
  }, {
    title: 'Santuario de Sueño:',
    desc: 'El sistema para eliminar la niebla mental mediante la limpieza de desechos cerebrales nocturnos.'
  }];
  return <section className="py-24 bg-[#132118] border-y border-white/5" data-id="element-134">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-137">
            Todo lo que incluye tu protocolo
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-138">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex items-start gap-4 bg-[#162019] p-6 rounded-xl border border-white/5 hover:border-emerald-500/20 transition-colors" data-id="element-139">
              <CheckCircle2 className="w-6 h-6 text-emerald-400 shrink-0 mt-0.5" data-id="element-140" />
              <p className="text-lg text-gray-300" data-id="element-141">
                <strong className="text-white font-semibold" data-id="element-142">
                  {item.title}
                </strong>{' '}
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}